import { Box, Button, Form, FormField, TextInput } from "grommet";
import React, { useEffect, useState } from "react";

function EditUserForm({ currentUserAttributes, handleSubmit, handleBack }) {
    const [editedUserAttributes, setEditedUserAttributes] = useState(currentUserAttributes);
    const [error, setError] = useState();

    useEffect(() => {
        setEditedUserAttributes(currentUserAttributes);
        setError(undefined);
    }, [currentUserAttributes]);

    const handleFormSubmit = ({ value }) => {
        handleSubmit(value).then(() => setError(undefined))
            .catch(({ message }) => setError(message));
    }

    return (
        <Form
            onSubmit={handleFormSubmit}
            onChange={setEditedUserAttributes}
            value={editedUserAttributes}
        >
            {error && <p className="status-error" role="alert">Error: {error}</p>}
            <FormField name="name" htmlFor="name-input" label="Name">
                <TextInput id="name-input" name="given_name" maxLength={50}/>
            </FormField>
            <FormField name="name" htmlFor="username-input" label="Username">
                <TextInput id="username-input" name="preferred_username" maxLength={50}/>
            </FormField>
            <FormField name="email" htmlFor="email-input" label="Email">
                <TextInput id="email-input" name="email"/>
            </FormField>
            <Box direction="row" gap="medium">
                <Button label="Back" onClick={handleBack}/>
                <Button type="submit" primary label="Save"/>
            </Box>
        </Form>
    )
}

export default EditUserForm;